// extracted by mini-css-extract-plugin
module.exports = {"inner":"sharing_inner_2f75n","padd":"sharing_padd_3n_Ls"};